export interface SelectedActivity {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
  variant?: string;
  order?: number;
  customPhotoUrl?: string;
}

export interface OrderData {
  orderType: 'custom' | 'curated';
  selectedActivities: SelectedActivity[];
  activityVariants?: Record<number, string>;
  frequency?: number;
  description?: string;
}

const STORAGE_KEY = 'yumeli_order_data';

export const saveOrderData = (data: OrderData): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getOrderData = (): OrderData | null => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const clearOrderData = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};